export enum ItemsTableFormatEnum {
  AMOUNT = 'AMOUNT',
  HTML = 'HTML'
}
